export const ASSIGN_VEHICLE_REQUEST = 'ASSIGN_VEHICLE_REQUEST'
export const ASSIGN_VEHICLE_SUCCESS = 'ASSIGN_VEHICLE_SUCCESS'
export const ASSIGN_VEHICLE_FALIURE = 'ASSIGN_VEHICLE_FALIURE'
